export function buildTinyMceOptions (height = 420) {
  return {
    language: 'b2b_lang',
    zindex: 6000,
    menubar: false,
    statusbar: true,
    toolbar_mode: 'wrap',
    height,
    min_height: height,
    autoresize_min_height: height,
    skin: false,
    content_css: false,
    license_key: 'gpl',
    plugins: 'advlist autolink lists link image charmap preview anchor pagebreak searchreplace visualblocks code fullscreen insertdatetime media table wordcount',
    toolbar: 'code preview | undo redo | fontfamily | fontsize | bold italic underline removeformat | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image table'
  }
}

export function registerTinyMceI18n (translate) {
  const tiny = globalThis.tinymce
  if (!tiny?.addI18n) return

  tiny.addI18n('b2b_lang', {
    Bold: translate('mailTemplates.editor.toolbar.bold_tooltip'),
    Italic: translate('mailTemplates.editor.toolbar.italic_tooltip'),
    Underline: translate('mailTemplates.editor.toolbar.underline_tooltip'),
    'Bullet list': translate('mailTemplates.editor.toolbar.bulletList_tooltip'),
    'Numbered list': translate('mailTemplates.editor.toolbar.orderedList_tooltip'),
    'Insert/edit link': translate('mailTemplates.editor.toolbar.link_tooltip'),
    'Insert link': translate('mailTemplates.editor.toolbar.link_tooltip'),
    'Insert/edit image': translate('mailTemplates.editor.toolbar.image_tooltip'),
    'Insert image': translate('mailTemplates.editor.toolbar.image_tooltip'),
    Undo: translate('mailTemplates.editor.toolbar.undo_tooltip'),
    Redo: translate('mailTemplates.editor.toolbar.redo_tooltip'),
    'Align left': translate('mailTemplates.editor.toolbar.alignLeft_tooltip'),
    'Align center': translate('mailTemplates.editor.toolbar.alignCenter_tooltip'),
    'Align right': translate('mailTemplates.editor.toolbar.alignRight_tooltip'),
    Justify: translate('mailTemplates.editor.toolbar.justify_tooltip'),
    'Decrease indent': translate('mailTemplates.editor.toolbar.outdent_tooltip'),
    'Increase indent': translate('mailTemplates.editor.toolbar.indent_tooltip'),
    'Source code': translate('mailTemplates.editor.toolbar.sourceCode_tooltip'),
    Code: translate('mailTemplates.editor.toolbar.sourceCode_tooltip'),
    Preview: translate('mailTemplates.editor.toolbar.preview_tooltip'),
    Table: translate('mailTemplates.editor.toolbar.table_tooltip'),
    'Clear formatting': translate('mailTemplates.editor.toolbar.removeFormat_tooltip'),
    'Remove formatting': translate('mailTemplates.editor.toolbar.removeFormat_tooltip'),
    'Font family': translate('mailTemplates.editor.toolbar.fontFamily_tooltip'),
    'Font size': translate('mailTemplates.editor.toolbar.fontSize_tooltip'),
    'Font Family': translate('mailTemplates.editor.toolbar.fontFamily_tooltip'),
    'Font Sizes': translate('mailTemplates.editor.toolbar.fontSize_tooltip'),
    Save: translate('buttons.btnSave'),
    Cancel: translate('buttons.btnCancel'),
    Close: translate('buttons.btnClose')
  })
}
